import type * as React from "react";

import { cn } from "@/lib/utils";

import { type VariantProps, cva } from "class-variance-authority";

const badgeVariants = cva(
  [
    "inline-flex",
    "items-center",
    "rounded",
    "h-fit-content",
    "focus:outline-none",
    "focus:ring-2",
    "focus:ring-ring",
    "focus:ring-offset-2",
    "p-1",
    "gap-1",
    "border-none",
    "text-body-sm",
    "[&>svg]:w-3",
    "[&>svg]:h-3",
  ],
  {
    variants: {
      variant: {
        default: "bg-tertiary",
        warning: "bg-warning",
        error: "bg-error",
        "error-contrast": "bg-error-contrast",
        light: "bg-secondary",
        info: "bg-info",
        success: "bg-success",
        ai: "bg-superclinical",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
